import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useNavigate } from 'react-router-dom';
import TitleBox from '../../components/common/breadcrumbs/TitleBox';
import DetailTemplate from '../../components/common/template/DetailTemplate';
import TaxbillTemplate from '../../components/paymentmng/TaxbillTemplate';
import { unloadTaxbill, viewTaxbill } from '../../modules/payModule/taxbill';
import TaxBillColAndPayFormContainer from './TaxBillColAndPayFormContainer';
import TaxBillDetailContainer from './TaxBillDetailContainer';
import TaxBillIssuedFormContainer from './TaxBillIssuedFormContainer';
import TaxBillPerformConfirmFormContainer from './TaxBillPerformConfirmFormContainer';

const PaymentEditContainer = () => {
  const { id } = useParams();
  let navigate = useNavigate();
  const [titleData, setTitleData] = useState(null);

  const dispatch = useDispatch();
  const { taxbill, roInfo, error, loading } = useSelector(
    ({ payModule, loading }) => ({
      taxbill: payModule.taxbill.taxbill,
      roInfo: payModule.taxbill.roInfo,
      error: payModule.taxbill.error,
      loading: loading['taxbill/VIEW_TAXBILL'],
    }),
  );

  useEffect(() => {
    dispatch(viewTaxbill(id));

    //언마운트될때 리덕스에서 데이터 초기화
    return () => {
      dispatch(unloadTaxbill());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (taxbill) {
      let title = {
        name: taxbill.invNo,
        no: taxbill.invNo,
      };
      setTitleData(title);
    }
  }, [taxbill]);

  const handleGoBack = () => {
    navigate(`/paymentmng/${id}`);
  };

  return (
    <TaxbillTemplate taxbill={taxbill} loading={loading} error={error}>
      <TitleBox
        handleGoBack={handleGoBack}
        menuName="세금계산서 관리/수금 관리/수정"
        menuLink="/paymentmng"
        icon="taxbill"
        titleData={titleData}
      />
      <DetailTemplate title="기본사항">
        <TaxBillDetailContainer taxbill={taxbill} roInfo={roInfo} />
      </DetailTemplate>
      <DetailTemplate title="계산서 발행">
        <TaxBillIssuedFormContainer />
      </DetailTemplate>
      <DetailTemplate title="수금&amp;지급">
        <TaxBillColAndPayFormContainer />
      </DetailTemplate>
      {/* <DetailTemplate title="실적확정">
        <TaxBillPerformConfirmFormContainer />
      </DetailTemplate> */}
    </TaxbillTemplate>
  );
};

export default PaymentEditContainer;
